import { push } from './EasyLoisirsGTMClient';

const sendDataLayerVariableGTM = value => {
  push(value); // value is a parameter to send like sendDataLayerVariableGTM({'user_id':'blabla'});
};

export default sendDataLayerVariableGTM;
